import { FC, useMemo } from 'react';
import styles from './UndergroundIcon.css';

import { getUndergroundIcon } from './utils';

interface IUndergroundIconProps {
  regionId: number;
  color: string;
}
export const UndergroundIcon: FC<IUndergroundIconProps> = ({ regionId, color }) => {
  const icon = useMemo(() => getUndergroundIcon(regionId), [regionId]);

  return (
    <div style={{ color: `#${color}` }} className={styles['icon']}>
      {icon}
    </div>
  );
};
